import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock } from 'lucide-react';
export function StoryHook() {
  return <section className="bg-[#FDF6EE] text-stone-800 py-24 px-4" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <FadeIn data-id="element-122">
          <div className="flex items-center gap-4 mb-8 text-amber-700" data-id="element-123">
            <Clock className="w-8 h-8" data-id="element-124" />
            <span className="text-2xl font-bold tracking-wide uppercase" data-id="element-125">
              La Realidad de Cada Mañana
            </span>
          </div>

          <div className="space-y-8 text-xl md:text-2xl leading-relaxed text-stone-700 font-medium" data-id="element-126">
            <p className="first-letter:text-6xl first-letter:font-black first-letter:text-amber-600 first-letter:mr-3 first-letter:float-left" data-id="element-127">
              Son las 6:30 AM. Suena el despertador y, antes de abrir los ojos,
              ya lo sientes: ese dolor punzante en las rodillas, la espalda baja
              que parece de metal oxidado y esa rigidez que te hace caminar como
              un pingüino hacia el baño.
            </p>
            <p data-id="element-128">
              Te han dicho que es "la edad", que es "normal a los 45" y que te
              tomes un ibuprofeno. Pero tú sabes que cada mañana el dolor es un
              poco más fuerte y tu mundo se hace un poco más pequeño.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}